/**
 * OpenAI Ads pixel (oaiq). Single source of truth so every page inits the
 * same pixel exactly once. Idempotent: the `oaiq` guard prevents double-loading
 * across Inertia navigations, so it's safe to call from any page's mount effect.
 *
 * Pair initOpenAiPixel() (base loader + PageView) with oaiqMeasure() for
 * conversion events, e.g. registration_completed on signup.
 *
 * Provided by OpenAI Ads setup for dbestchatbot.com.
 */
export const OPENAI_PIXEL_ID = 'KmoNmfLGdhdHRbFKTxM212';

export function initOpenAiPixel(): void {
  if (typeof window === 'undefined' || (window as any).oaiq) return;
  /* eslint-disable */
  (function (w: any, d: any, s: any, u: any) {
    if (w.oaiq) return;
    var q: any = function () { q.q.push(arguments); }; q.q = []; w.oaiq = q;
    var j: any = d.createElement(s); j.async = 1; j.src = u;
    var f: any = d.getElementsByTagName(s)[0]; f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'https://bzrcdn.openai.com/sdk/oaiq.min.js');
  // debug:true surfaces event logs in the browser console + OpenAI's pixel
  // debugger while we verify firing. Safe to flip to false once confirmed.
  (window as any).oaiq('init', { pixelId: OPENAI_PIXEL_ID, debug: true });
  /* eslint-enable */
}

/**
 * Fire an OpenAI Ads conversion/measure event. No-op if the pixel hasn't
 * loaded yet (e.g. SSR or an ad-blocker). Mirrors the oaiq("measure", …) API.
 */
export function oaiqMeasure(event: string, params: Record<string, any> = {}): void {
  if (typeof window === 'undefined' || !(window as any).oaiq) return;
  (window as any).oaiq('measure', event, params);
}
